import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import CategoriesSelector from '@/common/components/CategoriesSelector/CategoriesSelector'

import { productTaxonomyDisplayOptions } from './constants'
import * as Styles from './styles'

const ProductOptions = ({
  productTaxonomyDisplay,
  setProductTaxonomyDisplay,
  productTaxonomyIds,
  setProductTaxonomyIds,
  productCategories,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Opciones de producto')}</Text>
      <ComboBox
        label={t('Mostrar para')}
        menuItems={[
          { label: t('Todas las categorías de producto'), value: productTaxonomyDisplayOptions.all },
          { label: t('Categorías de producto seleccionadas'), value: productTaxonomyDisplayOptions.included },
          { label: t('Todas las categorías de producto no excluidas'), value: productTaxonomyDisplayOptions.excluded },
        ]}
        value={productTaxonomyDisplay}
        handleChange={e => setProductTaxonomyDisplay(e.target.value)}
        fullWidth
      />
      {productTaxonomyDisplay !== productTaxonomyDisplayOptions.all && (
        <CategoriesSelector
          categories={productCategories}
          value={productTaxonomyIds}
          onChange={setProductTaxonomyIds}
          placeholder=" "
          label={
            productTaxonomyDisplay === productTaxonomyDisplayOptions.included
              ? t('Categorías de producto seleccionadas')
              : t('Categorías de producto excluidas')
          }
        />
      )}
    </Styles.Container>
  )
}

export default ProductOptions
